/* Mixaloop Tawk.to bubble control (2026-10-22 v2): hide while cart drawer open; on mobile also hide (only when minimized) while the main Add to cart is on screen, so it never covers it */
(function(){
  function T(){return window.Tawk_API||{};}
  var drawerOpen=false,atcVisible=false,hidden=null;
  function minimized(){try{return typeof T().isChatMinimized!=='function'||T().isChatMinimized();}catch(e){return true;}}
  function apply(){
    var want=drawerOpen||(atcVisible&&window.innerWidth<768&&minimized());
    if(want===hidden)return;
    try{var f=T()[want?'hideWidget':'showWidget'];if(typeof f==='function'){f();hidden=want;}}catch(e){}
  }
  function init(){
    var d=document.getElementById('drawer-cart');
    if(d){var s=function(){drawerOpen=d.classList.contains('is-open');apply();};new MutationObserver(s).observe(d,{attributes:true,attributeFilter:['class']});}
    var btn=document.querySelector('.section--main-product .block--buy-buttons');
    if(btn&&'IntersectionObserver' in window){new IntersectionObserver(function(es){atcVisible=es[0].isIntersecting;apply();},{rootMargin:'0px 0px 140px 0px'}).observe(btn);}
    var w=T();var prev=w.onLoad;w.onLoad=function(){hidden=null;apply();if(typeof prev==='function')prev();};window.Tawk_API=w;
    setInterval(apply,1500);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();

/* mx mini DJ deck for Osaria preview player (2026-10-22). Only adds classes/elements around the app player. */
(function(){
  function deck(w){
    if(w.querySelector(":scope>.mx-deck-top"))return; w.classList.add('mx-deck');
    var lab=document.createElement('div');lab.className='mx-deck-top';
    var t=w.querySelector('.track-label-single-player');
    lab.innerHTML='<span class="mx-deck-pv">&#9679; Preview</span><span class="mx-deck-title"></span>';
    lab.querySelector('.mx-deck-title').textContent=(t&&t.textContent.trim())||document.title.split(/[–|-]/)[0].trim();
    w.insertBefore(lab,w.firstChild);
    var eq=document.createElement('div');eq.className='mx-deck-eq';eq.setAttribute('aria-hidden','true');
    for(var i=0;i<28;i++){var b=document.createElement('i');b.style.animationDelay=(-(i*137)%1000)+'ms';b.style.animationDuration=(600+(i*53)%500)+'ms';eq.appendChild(b)}
    w.appendChild(eq);
    var rec=document.createElement('div');rec.className='mx-deck-rec';rec.setAttribute('aria-hidden','true');w.appendChild(rec);
  }
  function scan(){document.querySelectorAll('.osaria-player-product-view-appblock').forEach(deck)}
  function st(e){var a=e.target;if(!a||a.tagName!=='AUDIO')return;var w=a.closest('.osaria-player-product-view-appblock');if(w)w.classList.toggle('mx-playing',!a.paused&&!a.ended)}
  ['play','playing','pause','ended'].forEach(function(n){document.addEventListener(n,st,true)});
  if(document.readyState!=='loading')scan();document.addEventListener('DOMContentLoaded',scan);
  var to;new MutationObserver(function(){clearTimeout(to);to=setTimeout(scan,150)}).observe(document.documentElement,{childList:true,subtree:true});
})();
